import { Component } from '@angular/core';
import { AutoUnsubscribe } from 'ngx-auto-unsubscribe';
import { HttpService } from 'app/shared/services/http.service';
import { ModalsService } from 'app/shared/services/modals.service';
import { SharedService } from 'app/shared/services/shared.service';
import { DictionaryService } from 'app/shared/services/dictionary.service';
import { GoogleAnalyticsService } from 'app/shared/services/google-analytics.service';

@AutoUnsubscribe()
@Component({
  selector: 'add-broadcast-component',
  templateUrl: './add-broadcast.component.html',
  styleUrls: ['./add-broadcast.component.scss'],
})
export class AddBroadcastComponent {
  public network: string;
  public messageText: string;
  public color: number;
  public subscriptions: Array<any>;

  constructor(
    public httpService: HttpService,
    public modalsService: ModalsService,
    public sharedService: SharedService,
    public dictionaryService: DictionaryService,
    public ga: GoogleAnalyticsService
  ) {
    this.network = 'All';
    this.messageText = '';
    this.color = 0;
    this.subscriptions = [];
  }

  ngOnDestroy() {}

  addBroadcast(status: number) {
    const params: any = {
      notificationAttributes: {
        message: this.messageText,
        status: status,
        color: this.color,
      },
      users: this.network,
    };
    if (!this.sharedService.isEmpty(this.messageText)) {
      this.subscriptions.push(
        this.httpService.post('notifications/createNotification', params).subscribe(
          (response: any) => {
            const successMessage: string =
              status === 1
                ? this.dictionaryService.get('MESSAGE_PUBLISHED_SUCCESSFULLY')
                : this.dictionaryService.get('MESSAGE_SAVED_AS_DRAFT_SUCCESSFULLY');
            if (response.success) {
              this.sharedService.showFlashMessage(successMessage, 'success');
              this.sharedService.sendMessage('BROADCAST_UPDATED');
              this.modalsService.hideModal();
            } else if (response.errors) {
              this.sharedService.showErrorFlashMessage(response.errors);
            } else {
              this.sharedService.showErrorFlashMessage();
            }
          },
          (error: any) => {
            this.sharedService.showErrorFlashMessage(error);
          }
        )
      );
    } else {
      this.sharedService.showFlashMessage(this.dictionaryService.get('MESSAGE_TEXT_IS_REQUIRED'), 'error');
    }
  }

  saveDraft() {
    this.addBroadcast(0);
  }

  publish() {
    this.addBroadcast(1);
  }
}
